import { TenantPublicInfo } from "../models/tenant.model";

export interface TenantState {
  tenant: TenantPublicInfo | null;
  loading: boolean;
  error: string | null;
}

export const tenantInitialState: TenantState = {
  tenant: null,
  loading: false,
  error: null
}; 